(function () {
    const shareButtons = document.querySelectorAll("[data-share]");

    if (shareButtons.length) {
        shareButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                const platform = button.getAttribute("data-share");
                const url = encodeURIComponent(window.location.href);
                const title = encodeURIComponent(document.title);
                let shareUrl = "";

                switch (platform) {
                    case "facebook":
                        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
                        break;
                    case "twitter": // Still using Twitter endpoint even though branded X
                        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
                        break;
                    case "linkedin":
                        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
                        break;
                    default:
                        return;
                }

                window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
            });
        });
    }
})();

